/** Run The callback when the node has been added to the visible div.
 * 
 * This is useful to run code that needs to measure elements as it only weorks when the elements are visible. 
*/
export class OnVisibleRunner {
    private element;
    private callback: () => void;
    private observer: MutationObserver;
    private holder: any;
    private static listeners = new WeakSet();

    public static add(element, callback) {
        if (!this.listeners.has(element)) {
            new OnVisibleRunner(element, callback);
            OnVisibleRunner.listeners.add(element);
        }
    }

    constructor(element, callback) {
        this.callback = callback
        this.element = element;
        if (OnVisibleRunner.isElementVisible(this.element)) {
            this.callback();
        } else {
            this.holder = document.querySelector(".js-stack-holder");
            this.observer = new MutationObserver(this.mutationCallback);
            let config = {
                childList: true,
                characterData: false,
                attributes: false,
                subtree: true,
            };
            this.observer.observe(this.holder, config);
        }
    }

    private mutationCallback: MutationCallback = (mutations: MutationRecord[]) => {
        if (OnVisibleRunner.isElementVisible(this.element)) {
            OnVisibleRunner.listeners.delete(this.element);
            this.observer.disconnect();
            this.callback();
        }
    }

    public static isElementVisible(element) {
        if (element.offsetWidth ||
            element.offsetHeight ||
            element.getClientRects().length)
            return true;
        else
            return false;
    }
}
